import ContainerSimple from "../../../Components/ContainerSimple"
import InputAdmin from "../../../Components/InputFields/InputAdmin"
import Custom from "../../../Components/Buttons/Custom"
import MultipleSelectAdmin from "../../../Components/InputFields/MultipleSelectAdmin"
import { useState } from "react"

export default function EditRuleContainer({onClose}) {

  const [selectedChallenge, setSelectedChallenge] = useState("");

  return (
    <ContainerSimple>
          <div className="w-full flex gap-12">
            <InputAdmin label="وضعیت" id="type" name="type" type="select" selectOptions={["نمایش", "عدم نمایش"]} selectPlaceHolder="انتخاب کنید"/>
            <div className="w-full"></div>
          </div>
          <div className="w-full flex gap-12">
            <InputAdmin label="عنوان قانون" id="type" name="type" type="text"/>
          </div>
          <div className="w-full flex flex-col gap-2.5">
            <label htmlFor="notes" className="text-sm font-normal text-zi-text-light/50 dark:text-zi-text-dark/50">توضیحات قانون</label>
            <textarea
            id="notes"
            name="notes"
            className={`w-full h-40 leading-loose resize-none rounded-lg py-1 px-2.5 border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark appearance-none bg-transparent`}
          ></textarea>
          </div>
          <MultipleSelectAdmin header="انتخاب دسته قانون" search={false} footer="دسته قانون انتخاب شده" footerValue="۲ فاز عادی" 
            tableColumns={[{ key: "category", label: "دسته قانون" },]}
            tableData={[{category: "دو فاز عادی"},{category: "عمومی"},]}
          />
          <div className="w-full flex gap-2.5 mt-6">
            <Custom text="ایجاد قانون جدید" svg_name="checkMark" svgClassName="stroke-zi-text-dark" href="" className="!rounded-lg !p-2.5 w-full text-zi-text-dark bg-zi-gradient-button-blue" textShadow={true} svgShadow={true}
            onClick={onClose}
            />
            <Custom text="انصراف و بستن" svg_name="xMark" svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark" href="" className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark bg-transparent"
            onClick={onClose}
            />
          </div>
        </ContainerSimple>
  )
}